export const AUTH_CLICK_LOGIN = 'AUTH_CLICK_LOGIN';
export const AUTH_CLICK_REGISTER = 'AUTH_CLICK_REGISTER';
export const AUTH_CLICK_LOGOUT = 'AUTH_CLICK_LOGOUT';



// WEBPACK FOOTER //
// ./src/components/MobileNav/utils/mobileNavConstants.js